// `<dialog>` open/close that never crashes and degrades on browsers without a
// native dialog implementation.
//
// `HTMLDialogElement.showModal()` / `close()` are undefined in Safari < 15.4
// (older iPhones), Opera Mini, and some old Android WebViews — calling
// `dialog.showModal()` there throws `TypeError: dialog.showModal is not a
// function`, which kills the checkout / modal flow for exactly the restricted
// mobile-webview population that hits ad landing pages. `showModal()` can also
// throw `InvalidStateError` when the dialog is already open or not connected.
//
// Feature-detect and fall back to toggling the `open` attribute. The non-native
// path relies on the `.drawer-dialog:not([open]) { display: none }` rule in
// checkout-controls.css to show/hide (browsers without <dialog> lack the UA rule
// that does this natively). State is read via `hasAttribute("open")` rather than
// the `.open` IDL property so it works on HTMLUnknownElement too (a <dialog> in a
// browser with no dialog support). Guard: tests/unit/safe-dialog.test.ts.

export function syncDialogModal(dialog: HTMLDialogElement, shouldOpen: boolean): void {
  const isOpen = dialog.hasAttribute("open");
  if (shouldOpen && !isOpen) {
    if (typeof dialog.showModal === "function") {
      try {
        dialog.showModal();
        return;
      } catch {
        // already-open / not-connected / partial support — fall through to attr
      }
    }
    dialog.setAttribute("open", "");
  } else if (!shouldOpen && isOpen) {
    if (typeof dialog.close === "function") {
      try {
        dialog.close();
        return;
      } catch {
        // fall through to attribute removal
      }
    }
    dialog.removeAttribute("open");
  }
}
